// A utility component to format basic text separated by newlines into paragraphs.
export type Props = {
  text: string;
  className?: string;
  paragraphClassName?: string;
};

const SimpleFormat = ({ text, className, paragraphClassName }: Props) => {
  return (
    <div className={className}>
      {text.split('\n').map((line, index) => (
        <p className={paragraphClassName} key={index}>
          {line}
        </p>
      ))}
    </div>
  );
};

export default SimpleFormat;
